/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancersWorkforceMisclassificationThresholdResource
 */
export interface FreelancersWorkforceMisclassificationThresholdResource {
    /**
     * The unique identifier of the freelancers workforce misclassification threshold.
     * @type {string}
     * @memberof FreelancersWorkforceMisclassificationThresholdResource
     */
    misclassificationThresholdId?: string;
    /**
     * The name of the freelancer workforce misclassification threshold.
     * @type {string}
     * @memberof FreelancersWorkforceMisclassificationThresholdResource
     */
    name?: string;
    /**
     * The number of days before a job is considered overdue.
     * @type {number}
     * @memberof FreelancersWorkforceMisclassificationThresholdResource
     */
    daysThreshold?: number;
    /**
     * The ISO 3166-1 alpha-2 country codes that the misclassification threshold applies to.
     * @type {Set<string>}
     * @memberof FreelancersWorkforceMisclassificationThresholdResource
     */
    countryCodes?: Set<string>;
    /**
     * Email addresses of the recipients to notify when the threshold is triggered.
     * @type {Set<string>}
     * @memberof FreelancersWorkforceMisclassificationThresholdResource
     */
    recipientEmails?: Set<string>;
}

/**
 * Check if a given object implements the FreelancersWorkforceMisclassificationThresholdResource interface.
 */
export function instanceOfFreelancersWorkforceMisclassificationThresholdResource(value: object): value is FreelancersWorkforceMisclassificationThresholdResource {
    return true;
}

export function FreelancersWorkforceMisclassificationThresholdResourceFromJSON(json: any): FreelancersWorkforceMisclassificationThresholdResource {
    return FreelancersWorkforceMisclassificationThresholdResourceFromJSONTyped(json, false);
}

export function FreelancersWorkforceMisclassificationThresholdResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancersWorkforceMisclassificationThresholdResource {
    if (json == null) {
        return json;
    }
    return {
        
        'misclassificationThresholdId': json['misclassificationThresholdId'] == null ? undefined : json['misclassificationThresholdId'],
        'name': json['name'] == null ? undefined : json['name'],
        'daysThreshold': json['daysThreshold'] == null ? undefined : json['daysThreshold'],
        'countryCodes': json['countryCodes'] == null ? undefined : json['countryCodes'],
        'recipientEmails': json['recipientEmails'] == null ? undefined : json['recipientEmails'],
    };
}

export function FreelancersWorkforceMisclassificationThresholdResourceToJSON(value?: FreelancersWorkforceMisclassificationThresholdResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'misclassificationThresholdId': value['misclassificationThresholdId'],
        'name': value['name'],
        'daysThreshold': value['daysThreshold'],
        'countryCodes': value['countryCodes'] == null ? undefined : Array.from(value['countryCodes'] as Set<any>),
        'recipientEmails': value['recipientEmails'] == null ? undefined : Array.from(value['recipientEmails'] as Set<any>),
    };
}

